<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card>
      <v-card-title>确认删除</v-card-title>
      <v-card-text>
        <div>您确定要删除以下面经吗？</div>
        <div><strong>公司名称:</strong> {{ item.companyName }}</div>
        <div><strong>职位名称:</strong> {{ item.jobTitle }}</div>
        <div><strong>面试过程:</strong></div>
        <div v-html="item.detail"></div>
        <!-- <pre>{{ item }}</pre> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">取消</v-btn>
        <v-btn color="red" text @click="confirmDelete">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { interviewApi } from '@/api/interview'

export default {
  name: 'DeleteInterviewExpPopup',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      dialog: false
    }
  },

  methods: {
    open() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    async confirmDelete() {
      try {
        await interviewApi.deleteInterviewExperience(this.item.expId);
        this.$emit('interview-exp-deleted');
        this.close();
        this.$toast.success('面经删除成功');
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('删除失败：' + errorMessage);
      }
    }
  }
}
</script> 